"use client"

import { useCallback, useMemo } from 'react'
import { usePathname, useRouter } from 'next/navigation'
import useTranslatedArray from '@hooks/useTranslatedArray'
import Select from '@components/form/context/SelectIcon'

import {
    buyLinks,
    rentLinks,
    sellLinks,
    serviceLinks,

    BUY_CAR,
    RENT_CAR,
    SELL_CAR,
    SERVICE,
} from './AddFormLinks'

const actions = [
    'Sprzedaję',
    'Wynajmuję',
    'Oferuję usługę',
    'Chcę kupić',
]

const actionLinks = [
    SELL_CAR,
    RENT_CAR,
    SERVICE,
    BUY_CAR,
]

const actionVehicles = [
    sellLinks,
    rentLinks,
    serviceLinks,
    buyLinks,
]

const EMPTY_SELECT = <div/>

function useRouterSelectOnChangeCallback (values, links) {
    const router = useRouter()
    const onChange = useCallback((valueOrE) => {
        const value = (valueOrE || '').value || valueOrE
        if (value) {
            const idx = values.indexOf(value)
            if (idx != -1) router.push(links[idx])
        }
    }, [links, router, values])
    return onChange
}

function ActionSelect () {
    const pathname = usePathname()
    const displayValues = useTranslatedArray(actions)
    const onChange = useRouterSelectOnChangeCallback(actions, actionLinks)
    const defaultValue = actions.find((_, idx) => urlHasCommonBase(pathname, 2)(actionLinks[idx]))

    if (!actionLinks || !actionLinks.length) return EMPTY_SELECT
    return <Select
        defaultValue={defaultValue}
        displayOptions={displayValues}
        id="offer-type"
        label="Typ ogłoszenia"
        onChange={onChange}
        values={actions}
    />
}

function VehicleSelect () {
    const pathname = usePathname()
    const linkSet = useMemo(() => {
        const idx = actionLinks.findIndex(urlHasCommonBase(pathname,2))
        return actionVehicles[idx]
    }, [pathname])

    const [values, links, icons] = useMemo(() => {
        const values = []
        const links = []
        const icons = []
        for (const link of linkSet || []) {
            values.push(link.t)
            links.push(link.to)
            icons.push(link.svg)
        }
        return [values, links, icons]
    }, [linkSet])

    const displayValues = useTranslatedArray(values)
    const onChange = useRouterSelectOnChangeCallback(values, links)
    const defaultValue = values.find((_, idx) => pathname.startsWith(links[idx]))

    if (!links || !links.length) return EMPTY_SELECT
    return <Select
        defaultValue={defaultValue}
        displayOptions={displayValues}
        icons={icons}
        id="category"
        label="Kategoria"
        onChange={onChange}
        values={values}
    />
}

function LinkSelect ({ links, names, ...rest }) {
    const pathname = usePathname()
    const tNames = useTranslatedArray(names)
    const onChange = useRouterSelectOnChangeCallback(names, links)
    if (!links || !names) return null
    const defaultValue = names.find((_, idx) => pathname.startsWith(links[idx]))
    return <Select
        defaultValue={defaultValue}
        displayOptions={tNames}
        id="vehicle"
        label="Pojazd"
        onChange={onChange}
        values={names}
        {...rest}
    />
}

function urlHasCommonBase (currentPath = '', depth) {
    const currentUrlParts = currentPath.slice(1).split('/')
    return function (url) {
        const urlParts = url.slice(1).split('/')
        if (currentUrlParts.length != urlParts.length) return false
        let commonPartCount = 0
        for (let i = 0; i < currentUrlParts.length; i++) {
            const part = currentUrlParts[i]
            const part2 = urlParts[i]

            if (part != part2) break
            commonPartCount += 1
        }
        return commonPartCount >= depth
    }
}

export {
    ActionSelect,
    LinkSelect,
    Select,
    VehicleSelect,
}